import { ITableRes } from 'types'
import { baseApi } from './baseApi'

export const gradeLevelsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_gradeLevels: builder.query<ITableRes<any>, any>({
      query: (params) => ({
        url: '/grade-levels/',
        params,
      }),
      providesTags: ['grade-levels'],
    }),
    GET_gradeLevelById: builder.query<any, string>({
      query: (id) => {
        return {
          url: `/grade-levels/${id}/`,
        }
      },
      providesTags: ['grade-levels']
    }),
    POST_gradeLevel: builder.mutation<any, any>({
      query: (body) => ({
        url: `/grade-levels/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['grade-levels'],
    }),
    PUT_gradeLevel: builder.mutation<any, { id: string; body: any }>({
      query: ({ id, body }) => ({
        url: `/grade-levels/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['grade-levels'],
    }),
    DELETE_gradeLevel: builder.mutation<any, string>({
      query: (id) => ({
        url: `/grade-levels/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['grade-levels'],
    }),
  }),
})

export const { 
  useGET_gradeLevelsQuery, 
  useGET_gradeLevelByIdQuery, 
  usePOST_gradeLevelMutation, 
  usePUT_gradeLevelMutation, 
  useDELETE_gradeLevelMutation,
} = gradeLevelsAPI
